import React from "react";

const FormPreview = ({ form }) => {
  const fields = form?.fields || [];

  return (
    <div className="live-form-preview-card">
      <div className="live-preview-header">
        <p>Live Preview</p>
        <h2>{form?.title || "Untitled Form"}</h2>
        <span>{form?.description || "Your form preview will appear here."}</span>
      </div>

      <div className="live-preview-meta">
        <span>{form?.sub_category?.name || "No sub-category selected"}</span>
        <span>{fields.length} fields</span>
      </div>

      <div className="live-preview-form">
        {fields.length === 0 && (
          <div className="mini-empty">
            Add fields to preview the customer form.
          </div>
        )}

        {fields.map((field) => (
          <label key={field.form_field_id || field.field_name}>
            <span>
              {field.field_label}
              {field.is_required && <em>*</em>}
            </span>

            {field.input_type === "textarea" ? (
              <textarea placeholder={field.placeholder || ""} disabled />
            ) : field.input_type === "select" ? (
              <select disabled>
                <option>Select option</option>
                {(field.options || []).map((option) => (
                  <option key={option}>{option}</option>
                ))}
              </select>
            ) : field.input_type === "radio" ||
              field.input_type === "checkbox" ? (
              <div className="form-option-preview">
                {(field.options || []).map((option) => (
                  <span key={option}>
                    <input type={field.input_type} disabled />
                    {option}
                  </span>
                ))}
              </div>
            ) : (
              <input
                type={field.input_type === "file" ? "text" : field.input_type}
                placeholder={
                  field.input_type === "file"
                    ? "File upload field"
                    : field.placeholder || ""
                }
                disabled
              />
            )}
          </label>
        ))}
      </div>
    </div>
  );
};

export default FormPreview;